import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  lineChartRoot: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column"
  },
  track: {
    background: "#eeeeee",
    height: 6,
    borderRadius: 75,
    position: "relative"
  },
  trackExtended: {
    height: 7,
    background: "#333333"
  },
  slider: {
    position: "absolute",
    left: 0,
    height: "100%",
    borderRadius: 75,
    "&.naAlert": {
      stroke: theme.palette.primary.light
    },
    "&.nonAlert": {
      background: theme.palette.secondary.dark
    },
    "&.middleAlert": {
      background: "#eab32f"
    },
    "&.moderateAlert": {
      background: theme.palette.warning.main
    },
    "&.highAlert": {
      background: theme.palette.warning.dark
    }
  },
  lineChartText: {
    "&.highAlert": {
      color: theme.palette.warning.dark
    },
    "&.naAlert": {
      color: theme.palette.text.secondary
    }
  }
}));
